import React from 'react';
import { graphql } from 'gatsby';
import { Page } from '@mq/gatsby-components';

import IndexLayout from '../layouts';

import ComponentBlocks from '../containers/ComponentBlocks';

import {
  CustomPage,
  CustomPage_craft_entry_Craft_customPages_customPages_Entry as CustomPageEntry,
} from '@mq/generated-types/dist/CustomPage';

import { isQA, getMostRecentDraft } from '../utils/misc';

interface CraftData {
  data: CustomPage;
}

const CustomPageTemplate: React.FC<CraftData> = ({ data }) => {
  const { entry, drafts } = data.craft;
  let typedEntry = entry as CustomPageEntry;
  const typedDrafts = drafts as CustomPageEntry[];

  if (isQA && typedDrafts.length) {
    typedEntry = getMostRecentDraft(typedDrafts);
  }

  return (
    <IndexLayout>
      <Page>
        <ComponentBlocks pageBlocks={typedEntry.pageBlocks} />
      </Page>
    </IndexLayout>
  );
};

export default CustomPageTemplate;

export const CustomPageQuery = graphql`
  query CustomPage($slug: [String]!) {
    craft {
      entry(slug: $slug, type: "customPages") {
        ... on Craft_customPages_customPages_Entry {
          sourceId
          dateUpdated
          pageBlocks {
            ...PageBlocks
          }
        }
      }

      drafts: entries(slug: $slug, type: "customPages", drafts: true) {
        ... on Craft_customPages_customPages_Entry {
          sourceId
          dateUpdated
          pageBlocks {
            ...PageBlocks
          }
        }
      }
    }
  }
`;
